const SET_BRANCHES = 'SET_BRANCHES';
const SET_DS_BRANCHES = 'SET_DS_BRANCHES';

export { SET_BRANCHES, SET_DS_BRANCHES };
